import React from 'react'
import { Formik } from 'formik'
import FormField from '../../atoms/FormField/FormField'
import FormInput from '../../atoms/FormInput/FormInput'
import FormSelect from '../../atoms/FormSelect/FormSelect'
import FormTextarea from '../../atoms/FormTextarea/FormTextarea'
import Button from '../../atoms/Button/Button'
import { CONTATTO } from '../../../utils/endpoint'
import { useRouter } from 'next/router'
import { Trans } from '../../../components/index'
import useTrans from '../../../hooks/useTrans'
import { api } from '../../../utils'
import getValidationSchema from './validationSchema'
import { usePrivacy } from '../../../hooks/usePrivacy'
import { useSelector } from 'react-redux'
import { trackingGAEvent } from '../../../utils/gtm'

const FormContatti = ({ motivazioni, reparti, nazioni }) => {
  const router = useRouter()
  const t = useTrans()
  const { service_gift } = useSelector((state) => state.servicegift)
  const { getUrlInformativaFromStore } = usePrivacy()
  const validationSchema = getValidationSchema()
  const initialValues = {
    azienda: null,
    partita_iva: null,
    nome: null,
    email: null,
    telefono: null,
    reparto: null,
    nazione: null,
    motivazione: null,
    messaggio: null,
  }

  return (
    <div className="contatti_container">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        validateOnChange={true}
        validateOnBlur={true}
        onSubmit={(values) => {
          try {
            const params = {
              azienda: values.azienda,
              partita_iva: values.partita_iva,
              nome: values.nome,
              email: values.email,
              telefono: values.telefono,
              reparto: values.reparto,
              nazione: values.nazione,
              motivazione: values.motivazione,
              messaggio: values.messaggio,
            }
            api
              .post(CONTATTO, params)
              .then((res) => {
                router.push(`/contatti/success`)
              })
              .catch((error) => console.log(error))
          } catch (error) {
            console.log(error)
          }
        }}
      >
        {(props) => (
          <div className="contatti_container_form">
            <div className="field-content">
              <FormField
                label={t('Azienda *')}
                status={
                  props.touched.azienda && props.errors.azienda
                    ? 'error'
                    : props.touched.azienda && 'success'
                }
                errorMessage={props.errors?.azienda}
              >
                <FormInput
                  value={props.values.azienda}
                  onBlur={props.handleBlur('azienda')}
                  onChange={props.handleChange('azienda')}
                />
              </FormField>
              <FormField
                label={`${t('P.IVA')} *`}
                status={
                  props.touched.partita_iva && props.errors.partita_iva
                    ? 'error'
                    : props.touched.partita_iva && 'success'
                }
                errorMessage={props.errors?.partita_iva}
              >
                <FormInput
                  value={props.values.dati_aziendali?.partita_iva}
                  onChange={props.handleChange('partita_iva')}
                  onBlur={props.handleBlur('partita_iva')}
                ></FormInput>
              </FormField>
            </div>
            <div className="field-content">
              <FormField
                label={t('Nome e cognome *')}
                status={
                  props.touched.nome && props.errors.nome
                    ? 'error'
                    : props.touched.nome && 'success'
                }
                errorMessage={props.errors?.nome}
              >
                <FormInput
                  name="nome"
                  value={props.values.nome}
                  onBlur={props.handleBlur('nome')}
                  onChange={props.handleChange('nome')}
                />
              </FormField>
              <FormField
                label={t('e-mail *')}
                status={
                  props.touched.email && props.errors.email
                    ? 'error'
                    : props.touched.email && 'success'
                }
                errorMessage={props.errors?.email}
              >
                <FormInput
                  value={props.values.email}
                  onBlur={props.handleBlur('email')}
                  onChange={props.handleChange('email')}
                />
              </FormField>
            </div>
            <div className="field-content">
              <FormField
                label={t('Telefono *')}
                status={
                  props.touched.telefono && props.errors.telefono
                    ? 'error'
                    : props.touched.telefono && 'success'
                }
                errorMessage={props.errors?.telefono}
              >
                <FormInput
                  type="number"
                  value={props.values.telefono}
                  onBlur={props.handleBlur('telefono')}
                  onChange={props.handleChange('telefono')}
                />
              </FormField>
              <FormField
                label={t('Reparto *')}
                status={
                  props.touched.reparto && props.errors.reparto
                    ? 'error'
                    : props.touched.reparto && 'success'
                }
                errorMessage={props.errors?.reparto}
              >
                <FormSelect
                  isSearchable={true}
                  placeholder={t('Seleziona Reparto')}
                  options={
                    reparti &&
                    reparti.map((obj) => {
                      return {
                        label: obj.nome,
                        id: obj.id,
                      }
                    })
                  }
                  value={{
                    label: props.values.reparto
                      ? reparti.filter((reparto) => props.values.reparto === reparto.id)[0]?.nome
                      : '',
                  }}
                  onChange={(e) => {
                    props.setFieldValue('reparto', e.id)
                  }}
                  onBlur={props.handleBlur('reparto')}
                ></FormSelect>
              </FormField>
            </div>
            <div className="field-content">
              <FormField
                label={t('Nazione *')}
                status={
                  props.touched.nazione && props.errors.nazione
                    ? 'error'
                    : props.touched.nazione && 'success'
                }
                errorMessage={props.errors?.nazione}
              >
                <FormSelect
                  isSearchable={true}
                  placeholder={t('Seleziona Nazione')}
                  options={
                    nazioni &&
                    nazioni.map((obj) => {
                      return {
                        label: obj.nome,
                        id: obj.id,
                      }
                    })
                  }
                  value={{
                    label: props.values.nazione,
                  }}
                  onChange={(e) => {
                    props.setFieldValue('nazione', e.label)
                  }}
                  onBlur={props.handleBlur('nazione')}
                ></FormSelect>
              </FormField>
              <FormField
                label={t('Motivazione *')}
                status={
                  props.touched.motivazione && props.errors.motivazione
                    ? 'error'
                    : props.touched.motivazione && 'success'
                }
                errorMessage={props.errors?.motivazione}
              >
                <FormSelect
                  isSearchable={true}
                  placeholder={t('Seleziona Motivazione')}
                  options={
                    motivazioni &&
                    motivazioni.map((obj) => {
                      return {
                        label: obj.nome,
                        id: obj.id,
                      }
                    })
                  }
                  value={{
                    label: props.values.motivazione
                      ? motivazioni.filter(
                          (motivazione) => props.values.motivazione === motivazione.id
                        )[0]?.nome
                      : '',
                  }}
                  onChange={(e) => {
                    props.setFieldValue('motivazione', e.id)
                  }}
                  onBlur={props.handleBlur('motivazione')}
                ></FormSelect>
              </FormField>
            </div>
            <div className="field-content">
              <FormField
                label={t('Messaggio *')}
                style={{ padding: '1% 6%' }}
                status={
                  props.touched.messaggio && props.errors.messaggio
                    ? 'error'
                    : props.touched.messaggio && 'success'
                }
                errorMessage={props.errors?.messaggio}
              >
                <FormTextarea
                  placeholder={t('Inserisci un messaggio')}
                  onChange={props.handleChange('messaggio')}
                  value={props.values.messaggio}
                />
                <br />
              </FormField>
            </div>
            <div className="field-content" style={{ display: 'flex', flexDirection: 'column' }}>
              <p>
                <Trans chiave="*Campi obbligatori" />
              </p>

              {!service_gift?.attivo && (
                <p className="registrazione__template__disclaimer">
                  {t('Contattandoci, dichiari di aver letto e compreso')}{' '}
                  <a
                    target="_blank"
                    style={{ textDecoration: 'underline', fontWeight: 'bold' }}
                    href={getUrlInformativaFromStore()}
                  >
                    {t("l'Informativa Privacy")}
                  </a>
                </p>
              )}
            </div>
            <br />
            <div className="field-content">
              <Button
                disabled={!props.isValid}
                label={t('Manda Messaggio')}
                variant="primary"
                size="medium"
                type="submit"
                onClick={() => {
                  trackingGAEvent(
                    'contact_form_sent',
                    motivazioni?.find((m) => m.id === props?.values.motivazione)?.nome,
                    reparti?.find((m) => m.id === props?.values.reparto)?.nome
                  )
                  props.handleSubmit()
                }}
              />
            </div>
          </div>
        )}
      </Formik>
    </div>
  )
}

export default FormContatti
